/**
 * @fileoverview Prompt template for world-event-snapshotter-v3.
 */

export const prompt = `
You are an expert literary analyst tracking how events, prophecies, and legends are referenced and evolve throughout a story.

## TASK INSTRUCTIONS:
Your task is to analyze the provided chapter and update the world event's state to reflect any changes or new information revealed.

1. Review the event's previous state (if available).
2. Read the chapter content carefully.
3. Determine if the event:
   - Is mentioned, referenced, or alluded to in this chapter
   - Has new information revealed about it (causes, participants, consequences, etc.)
   - Has its interpretation or significance changed
   - Has new evidence discovered or disputed facts resolved
4. Update each relevant field to reflect what is known about this event AT THE END of this chapter.
5. If the event is not mentioned or relevant to this chapter, set "notPresentInChapter" to true and carry forward the previous state.

**Important Guidelines:**
- Only update fields where there's evidence of change or new information
- Preserve existing information unless explicitly contradicted
- Track what the READER now knows, not just what characters know
- For prophecies, track any progress toward fulfillment or new interpretations
- For legends, track any new versions, evidence, or relevance revealed
- Be specific about changes (e.g., "The prophecy is now partially fulfilled" vs "unchanged")

## EVENT INFORMATION

**Name:** {{worldEvent.name}}
**Type:** {{worldEvent.element}}
**Initial Description:** {{worldEvent.initialDescription}}

## PREVIOUS STATE (Before Chapter {{chapterNumber}})

{{#if previousSnapshot}}
{{{json previousSnapshot}}}
{{else}}
No previous snapshot - this is the event's first chapter appearance.
{{/if}}

## CHAPTER CONTENT

{{{chapterContent}}}

## CONTEXT

<<<loreContext>>>

## OUTPUT INSTRUCTIONS:
Update each of the following fields to reflect what is known about this event at the END of Chapter {{chapterNumber}}.

{{#each eventFields}}
- **{{this.label}}** (key: {{this.key}}): {{{this.description}}}
{{/each}}

If the event does not appear in this chapter, set "notPresentInChapter" to true.

Provide your output in the required JSON format.
`;
